import TableRow from "./TableRow";

const SystemAdminList = (props) => {
    return (
        <div className="row mt-5">
            <div className="col-md-12">
                <div className="card border">
                    <div className="card-body py-4">
                        <div id="sai_table_users_wrapper" className="dataTables dt-bootstrap4 no-footer">
                            <div className="table-responsive">
                                <table className="table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer">
                                    <thead>
                                        <tr className="text-start text-muted fw-bold fs-7 text-uppercase gs-0">
                                            <th className="w-300px sorting">Name</th>
                                            <th className="w-250px sorting">Email</th>
                                            <th className="w-250px sorting">Assigne Business</th>
                                            <th className="w-200px text-center">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody className="text-gray-600 fw-semibold set-system-user-list">
                                        {props.allSysAdmin.map((row, index) => (
                                            <TableRow row={row} key={index} deleteSuccess={props.systemAdminDeleted} editId={props.sysAdminEditId} />
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SystemAdminList;